import moment from 'moment';

var storageFilterCompletedTasksForAuthUser = JSON.parse(localStorage.getItem('filterCompletedTasksForAuthUser'));
var filterCompletedTasksForAuthUser = storageFilterCompletedTasksForAuthUser === null ? null : false;

const initialState = {
	userId: null,
	loading: true,
    selectedDate: moment().startOf('day'),
    selectedDateTasksEvents: [],
    selectedDateTasksPaginationData: null,
    overdueTasksEvents: [],
    overdueTasksPaginationData: null,
    filterCompletedTasksForAuthUser
};

export default function tasks(state = initialState, action = {}) {
	switch (action.type) {
		case 'DELETE_SCHEDULE_SUCCESS':
		    var scheduleId = action.result.scheduleDeletedId;

		    var selectedDateTasksEvents = state.selectedDateTasksEvents.filter(e => e.id != scheduleId);
		    var overdueTasksEvents = state.selectedDateTasksEvents.filter(e => e.id != scheduleId);

		    return {
		        ...state,
		        selectedDateTasksEvents,
		        overdueTasksEvents
		    };
		case 'UPDATE_SCHEDULE_SUCCESS':
		    var schedule = action.result;
		    var selectedDateTasksEvents = state.selectedDateTasksEvents.map(e => e.id == schedule.id ? schedule : e);
		    var overdueTasksEvents = state.selectedDateTasksEvents.map(e => e.id == schedule.id ? schedule : e);

		    return {
		        ...state,
		        selectedDateTasksEvents,
		        overdueTasksEvents
		    };
	    default:
	        return state;
	}
}



// WEBPACK FOOTER //
// ./app/reducers/tasks.js